import { render, staticRenderFns } from "./SharedDialog.vue?vue&type=template&id=0af03c5a&scoped=true&"
import script from "./SharedDialog.vue?vue&type=script&lang=js&"
export * from "./SharedDialog.vue?vue&type=script&lang=js&"
import style0 from "./SharedDialog.vue?vue&type=style&index=0&id=0af03c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af03c5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VDialog,VIcon,VSpacer})
